export default "__VITE_ASSET__Ft8TOEfB__"